import React, { memo, useCallback } from 'react';
import { Form } from 'react-final-form';
import { useDispatch } from 'react-redux';

import SecurityPageWrapper from '../security-page-wrapper/SecurityPageWrapper';
import LoginForm from './LoginForm';
import { loginYopValidation } from '../validation';
import validate from '../../utils/validate';
import { login } from '../../redux/security/securityActions';

const Login = () => {
  const dispatch = useDispatch();
  const loginInitialValues = {
    username: '',
    password: '',
    rememberMe: false,
  };

  const handleLogin = useCallback(
    (values) => {
      dispatch(login(values));
    },
    [dispatch],
  );

  return (
    <SecurityPageWrapper>
      <Form
        initialValues={loginInitialValues}
        onSubmit={handleLogin}
        validate={(values) => validate(values, loginYopValidation())}
        subscription={{ submitting: true, pristine: true }}
        render={({ handleSubmit }) => <LoginForm handleSubmit={handleSubmit} />}
      />
    </SecurityPageWrapper>
  );
};

export default memo(Login);
